module.exports = __webpack_public_path__ + "static/media/group_copy_3@2x.7136a7ee.png";